// Client analytics: fire-and-forget beacon to the server-side events endpoint
// (whitelisted there). Keeps the console.debug locally so dev flows stay visible.
export function track(event, properties = {}) {
  if (['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    console.debug('[analytics]', event, properties);
  }

  if (navigator.sendBeacon) {
    const payload = new Blob([JSON.stringify({ name: event, properties })], {
      type: 'application/json',
    });
    navigator.sendBeacon('/events', payload);
  }
}
